/* eslint-disable */
//@ts-ignore
import React from 'react';
import './styles.scss';
import { useStore } from '../../store/store';
import { useRemoteConfig } from 'core/hooks/use-remote-config';
import { PhotoProgress } from 'src/onboarding/components/ui/photo-progress';
import { useProgress } from 'src/onboarding/hooks/useProgress';

const getPositionInGroup = (groupIndex, currentUrl, routeGroups) => {
  const group = routeGroups[groupIndex];
  const position = group.indexOf(currentUrl);

  return ((position + 1) / group.length) * 100;
};

const ProgressBar = () => {
  const { routeGroups: groups } = useRemoteConfig();
  const { progress, completedGroups } = useProgress(groups);
  const firstFalseIndex = completedGroups.findIndex((value) => value === false);
  const currentPage = useStore((state) => state.currentPage);
  const isValidUrl = groups.flat(1).includes(currentPage);

  if (!isValidUrl) return null;
  // Post-payment email page is outside the quiz progress — hide the bar there.
  if (currentPage === 'email-after-payment') return null;
  return (
    <div className='progress-bar-container'>
      {groups.map((group, index) => {
        const isCurrentGroup = progress >= (index + 1 / groups.length) * 100;
        return (
          <div key={index} style={{ flex: 1, height: 10, position: 'relative' }}>
            <div className={`item ${isCurrentGroup ? 'current-item' : ''}`}>
              <div
                style={{
                  height: '100%',
                  width: completedGroups[index]
                    ? '100%'
                    : index === firstFalseIndex
                      ? `${getPositionInGroup(index, currentPage, groups)}%`
                      : `0%`,
                  backgroundColor: '#000000',
                  transition: 'width 0.3s ease-in-out',
                  borderRadius: 90,
                }}
              ></div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

const MainLayoutNew = ({ children }) => {
  const showPhotoProcessing = useStore((state) => state.showPhotoProcessing);
  const { showPhotoProgress } = useRemoteConfig();

  return (
    <div
      className={'layout'}
      style={showPhotoProcessing && showPhotoProgress ? { gap: 30 } : { gap: 80 }}
    >
      <ProgressBar />
      {showPhotoProcessing && showPhotoProgress && <PhotoProgress />}

      {children}
    </div>
  );
};

export default MainLayoutNew;
